// Dependencias externas de compilación
window.moment = require('moment');
window._ = require('lodash');
window.Dropzone = require('dropzone');

try {
  window.$ = window.jQuery = require('jquery');
  require('jquery-ui');
  require('jquery-number');
  require('jquery-validation');
  require('jquery-slimscroll');
  require('bootstrap-sass');
  require('bootstrap-switch');
  require('bootstrap-hover-dropdown');
  require('select2');
  require('@fancyapps/fancybox');
  require('bootstrap-datepicker');
  require('datatables.net-dt');
  require('datatables.net-bs');
  require('datatables.net-fixedcolumns-dt');
  require('datatables.net-fixedheader-dt');
  //require('dropzone');
} catch (e) {
}

require("../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min");

// Metronic
window.Cookies = require('../../public/vendor/metronic/assets/global/plugins/js.cookie.min.js');
window.toastr = require('../../public/vendor/metronic/assets/global/plugins/bootstrap-toastr/toastr.js');
window.bootbox = require('../../public/vendor/metronic/assets/global/plugins/bootbox/bootbox.min.js');
require('../../public/vendor/metronic/assets/global/plugins/jquery.blockui.min.js');
require('../../public/vendor/metronic/assets/global/plugins/jquery-idle-timeout/jquery.idletimeout.js');
require('../../public/vendor/metronic/assets/global/plugins/jquery-idle-timeout/jquery.idletimer.js');
require('../../public/vendor/metronic/assets/global/plugins/jquery-slimscroll/jquery.slimscroll.js');
require('../../public/vendor/metronic/assets/global/plugins/bootstrap-fileinput/bootstrap-fileinput.js');
require('../../public/vendor/metronic/assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js');
//require('../../public/vendor/metronic/assets/global/plugins/bootstrap-sweetalert/sweetalert.js');
require('../../public/vendor/metronic/assets/global/plugins/icheck/icheck.min.js');
//require('../../public/vendor/metronic/assets/global/plugins/dropzone/dropzone.min');

// App & Layout modules
window.App = require('../../public/vendor/metronic/assets/global/scripts/app.module.js');
window.Layout = require('../../public/vendor/metronic/assets/layouts/layout4/scripts/layout.module.js');

// jQuery extends && Polyfills
require('./jquery.extends');
require('./polyfills');
